import { render } from "./PremiumModal.vue?vue&type=template&id=4cddff00"
import script from "./PremiumModal.vue?vue&type=script&lang=js"
export * from "./PremiumModal.vue?vue&type=script&lang=js"

import "./PremiumModal.vue?vue&type=style&index=0&id=4cddff00&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__